import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { BaseHttpService } from './base-http.service';
import { AuthResponse } from '../interfaces/auth.interface';
import { JobTitle, CreateJobTitleRequest, UpdateJobTitleRequest } from '../interfaces/job-title.interface';
import { API_ENDPOINTS } from '../constants/api.constants';

/**
 * Service for job title management operations
 */
@Injectable({
  providedIn: 'root'
})
export class JobTitlesService extends BaseHttpService {

  /**
   * Gets all job titles
   */
  getAllJobTitles(): Observable<JobTitle[]> {
    if (!this.hasValidToken()) {
      return this.returnEmptyArrayWhenNoToken<JobTitle>();
    }

    return this.get<JobTitle[]>(API_ENDPOINTS.AUTH.JOB_TITLES);
  }

  /**
   * Creates a new job title
   */
  createJobTitle(jobTitle: CreateJobTitleRequest): Observable<AuthResponse> {
    if (!this.hasValidToken()) {
      return this.returnErrorWhenNoToken('Nincs bejelentkezve');
    }

    return this.post<AuthResponse>(API_ENDPOINTS.AUTH.JOB_TITLES, jobTitle);
  }

  /**
   * Updates an existing job title
   */
  updateJobTitle(jobTitleId: number, jobTitle: UpdateJobTitleRequest): Observable<AuthResponse> {
    if (!this.hasValidToken()) {
      return this.returnErrorWhenNoToken('Nincs bejelentkezve');
    }

    const endpoint = `${API_ENDPOINTS.AUTH.JOB_TITLES}/${jobTitleId}`;
    return this.put<AuthResponse>(endpoint, jobTitle);
  }

  /**
   * Deletes a job title
   */
  deleteJobTitle(jobTitleId: number): Observable<AuthResponse> {
    if (!this.hasValidToken()) {
      return this.returnErrorWhenNoToken('Nincs bejelentkezve');
    }

    const endpoint = `${API_ENDPOINTS.AUTH.JOB_TITLES}/${jobTitleId}`;
    return this.delete<AuthResponse>(endpoint);
  }
}